import { render } from "./HeaderTitleBar.vue?vue&type=template&id=b47d8a5c&ts=true"
import script from "./HeaderTitleBar.vue?vue&type=script&lang=ts"
export * from "./HeaderTitleBar.vue?vue&type=script&lang=ts"

import "./HeaderTitleBar.vue?vue&type=style&index=0&id=b47d8a5c&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__